// extracted by mini-css-extract-plugin
export default {"loadingIndicator":"FhTQalQz","shouldRotate":"krFuRC4I","loadingAnimation":"OSA3idD3","loadingPage":"Jk_tJIhT"};